import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const IframeHeightSync = () => {
  const location = useLocation();

  useEffect(() => {
    // 1. Configure iframe-resizer child options
    window.iFrameResizer = {
      checkOrigin: false
    };

    // 2. Recalculate height whenever path or query params change
    const triggerResize = () => {
      if (window.iFrameResizer && typeof window.iFrameResizer.size === 'function') {
        window.iFrameResizer.size();
      }
    };

    // Immediate calculation
    triggerResize();

    // Delayed calculation to account for image/API loading on pages like /complete-diamond-ring
    const timer1 = setTimeout(triggerResize, 150);
    const timer2 = setTimeout(triggerResize, 500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, [location.pathname, location.search]);

  return null;
};

export default IframeHeightSync;